const config = {
    email: {
        token: "fdbbb50b-689d-4cf8-af2b-4d1986c27761",
        from: "contact@savesolidarity.org",
        to: "joseluissilvestregarcia@gmail.com",
    },
}

export default config;